import { BoxProps, ColorOptions } from '@jfs/ui-new'

const creditCardStyles = (merchantTheme: any) => ({
  errorContainer: {
    height: '20px',
    direction: 'row',
    align: 'center',
  } as BoxProps,
  container: {
    // bg: 'BG_PRIMARY',
  } as BoxProps,
  creditCardContainer: {
    direction: 'column',
  } as BoxProps,
  cardContainer: {
    direction: 'row',
    align: 'center',
  } as BoxProps,
  cvvContainer: {
    direction: 'row',
    align: 'center',
  } as BoxProps,
  cardHolderContainer: {
    direction: 'row',
    align: 'center',
  } as BoxProps,
  conatiner: {
    height: '100%',
    align: 'center',
    justify: 'space-between',
    flexDirection: 'column',
  } as BoxProps,
  mobileContainer: (isEnoughSpace: any) =>
    ({
      height: '100%',
      flex: 1,
      overflowY: isEnoughSpace ? 'unset' : 'scroll',
      bg: merchantTheme?.bodyBgColor as ColorOptions,
    } as BoxProps),
  innerContainer: {
    width: '530px',
    p: 'SMALL',
    bg: 'BG_WHITE',
    alignSelf: 'center',
  } as BoxProps,
  mobileInnerContainer: {
    flexGrow: 1,
    p: 0,
    bg: merchantTheme?.bodyBgColor as ColorOptions,
    alignSelf: 'stretch',
  } as BoxProps,
})

export { creditCardStyles }
